// Depends
import { group, route, meta } from '@/helpers/routes'

import SearchAdvanced from './search/advanced/agenda'
import SearchProfessional from './search/professional/agenda'
import SearchSpeciality from './search/speciality/agenda'
import Search from './search/basic/agenda'
import Schedulings from './schedulings/scheduled/index/index'
import SchedulingsHistory from './schedulings/history/index/index'
import Results from './search/results/agendas'

const agendaRoutes = [
  route('search', '/search', Search, meta('Selecione o tipo de Pesquisa', true, 'guest')),
  route('search/advanced', '/search/advanced', SearchAdvanced, meta('Pesquisar Avançada', true, 'guest')),
  route('search/speciality', '/search/speciality', SearchSpeciality, meta('Pesquisa por Especialidade', true, 'guest')),
  route('search/professional', '/search/professional', SearchProfessional, meta('Pesquisa por Nome do Profissional', true, 'guest')),
  route('search/results', '/search/results', Results, meta('Resultado da pesquisa', true, 'guest')),
  route('schedulings', '/schedulings/scheduled', Schedulings, meta('Lista de Agendas', true, 'guest')),
  route('schedulings/history', '/schedulings/history', SchedulingsHistory, meta('Histórico de Agedamentos'))
]

export default [
  ...group('/app/patient/agendas', agendaRoutes)
]



// WEBPACK FOOTER //
// ./src/app/patient/agendas/routes.js